<template>
  <div>
    <div
      class="sms-message-container p-3 mt-3"
      :class="{
        'input--error':
          isSubmit &&
          (errorMessageTemplates || checkMessageTemplatesSmsErrorExist),
      }"
    >
      <h5 class="mb-0">SMS</h5>
      <CommonMessageTemplate
        v-model="messageTemplateSms"
        :trigger-type="triggerType"
        :has-top40="hasTop40"
        :is-submit="isSubmit"
        :is-broadcast="isBroadcast"
        :is-remark-shown="isRemarkShown"
        :is-disabled="isDisabled"
        label="Message template"
        :data-id="dataId"
        :identifier="identifier + '_smsMessage'"
        :error-message-template="errorMessageTemplates"
        :exclude-customer-section="excludeCustomerSection"
      />
    </div>
    <div
      v-if="isSubmit && errorMessageTemplatesArray.length > 0"
      class="text-error"
    >
      <div v-for="(e, i) in errorMessageTemplatesArray" :key="i">
        <div v-if="+e.fieldName.substring(18) === index + 1" class="text-error">
          {{ e.message }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonMessageTemplate from "components/MessageTemplate/CommonMessageTemplate.vue";

export default {
  name: "SmsMessageTemplate",
  components: { CommonMessageTemplate },
  props: {
    triggerType: {
      type: String,
      default: () => null,
    },
    hasTop40: {
      type: Boolean,
      default: () => false,
    },
    identifier: {
      type: String,
      default: () => "",
    },
    messageTemplate: {
      type: Object,
      default: () => {},
    },
    errorMessageTemplates: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: () => null,
    },
    errorMessageTemplatesArray: {
      type: Array,
      default: () => [],
    },
    isSubmit: {
      type: Boolean,
      default: () => false,
    },
    isBroadcast: {
      type: Boolean,
      default: () => false,
    },
    dataId: {
      type: String,
      default: () => "",
    },
    isRemarkShown: {
      type: Boolean,
      default: () => false,
    },
    isDisabled: {
      type: Boolean,
      default: () => false,
    },
    excludeCustomerSection: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    messageTemplateSms: {
      get: function () {
        return this.messageTemplate?.messageTemplateSms;
      },
      set: function (newValue) {
        if (this.messageTemplate) {
          this.messageTemplate.messageTemplateSms = newValue;
        }
      },
    },
    checkMessageTemplatesSmsErrorExist() {
      return this.errorMessageTemplatesArray?.find(
        (e) => +e.fieldName.substring(18) === this.index + 1
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.sms-message-container {
  border: 2px solid #d2d0d0;
  border-radius: 5px;
}

.text-error {
  color: red;
  font-size: 12px;
}
</style>
